const actions = {
  SET_STATE: 'country/SET_STATE',
  ALL: 'country/ALL',
  SELECT: 'country/SELECT'
};

export default actions
